// src/com/auto_plan_bind/AutoPlanBindGql.js
import { gql } from "@apollo/client";

/*

extend type Mutation {
    autoPlanBindBuild(autoPlanBind: InputAutoPlanBindBuild!): CommonResponse! # 자동배차 동적 생성.
    autoPlanBindClear(autoPlanBind: InputAutoPlanBindClear!): CommonResponse! # 자동배차 동적 일괄 삭제.
}
input InputAutoPlanBindBuild {
	planDate: String!
}

input InputAutoPlanBindClear {
	planDate: String!
}


*/

export const BUILD_AUTO_PLAN_BIND = gql`
mutation BuildAutoPlanBind($autoPlanBind: InputAutoPlanBindBuild!) {
    autoPlanBindBuild(autoPlanBind: $autoPlanBind) {
        ok
        message
    }
}
`;

export const CLEAR_AUTO_PLAN_BIND = gql`
mutation ClearAutoPlanBind($autoPlanBind: InputAutoPlanBindClear!) {
    autoPlanBindClear(autoPlanBind: $autoPlanBind) {
        ok
        message
    }
}
`;

